import { render, staticRenderFns } from "./ApexColumnCharts.vue?vue&type=template&id=c4716988"
import script from "./ApexColumnCharts.vue?vue&type=script&lang=js"
export * from "./ApexColumnCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports